var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" This is a private system. All rights reserved. Powered by "),_c('a',{attrs:{"href":"https://mc256.dev"}},[_vm._v("mc256.dev")]),_vm._v(". ")])
}]

export { render, staticRenderFns }